import { render } from "./comment_list.vue?vue&type=template&id=5803405d&scoped=true&ts=true"
import script from "./comment_list.vue?vue&type=script&lang=ts"
export * from "./comment_list.vue?vue&type=script&lang=ts"

import "./comment_list.vue?vue&type=style&index=0&id=5803405d&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5803405d"]])

export default __exports__